import { render, staticRenderFns } from "./LanguageTestScore.vue?vue&type=template&id=623254e8"
import script from "./LanguageTestScore.vue?vue&type=script&lang=js"
export * from "./LanguageTestScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports